import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import ApiForbiddenError from "src/utils/Api/ApiForbiddenError";
import ApiResponseError from "src/utils/Api/ApiResponseError";
import { getSession } from "src/utils/RoleBasedSecurity/Session";
import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";

const interceptRequest = async (config: InternalAxiosRequestConfig) => {
  const session = await getSession();

  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = `Bearer ${await session.getValidAccessToken()}`;

  return config;
};

const interceptSuccessResponse = (response: AxiosResponse) => response;

const interceptorErrorResponse = (error: unknown) => {
  if (error instanceof Error) {
    const axiosError = error as AxiosError;

    newRelicErrorReport(axiosError, "HR Tools error");

    if (
      [401, 403].includes(axiosError.response?.status as number) &&
      axiosError.config?.url !== "/v1/admin/absence-plans"
    ) {
      const errorMessage =
        "Taki zasób nie istnieje lub nie masz do niego dostępu.";

      throw new ApiForbiddenError(errorMessage);
    }
    if ([400].includes(axiosError.status as number)) {
      const url = axiosError.config?.url;
      const { status } = axiosError;
      let error = axiosError.response?.statusText;
      let errorMessage;
      try {
        const { code, message } = axiosError.response?.data as {
          code: string;
          message: string;
        };
        error = code;
        errorMessage = message;
      } catch (e) {
        errorMessage = "Niepoprawna odpowiedź z serwera";
      }
      throw new ApiResponseError(status, url, error, errorMessage);
    }
  }

  return Promise.reject(error);
};

const createAxiosInstance = () => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.request.use(interceptRequest);
  axiosInstance.interceptors.response.use(
    interceptSuccessResponse,
    interceptorErrorResponse
  );

  return axiosInstance;
};

export default createAxiosInstance;
